import { render } from "./NewCommentBox.vue?vue&type=template&id=41433474&ts=true"
import script from "./NewCommentBox.vue?vue&type=script&lang=ts"
export * from "./NewCommentBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__